module.exports = __webpack_public_path__ + "static/media/kryptos.3acb01e5.webp";